import ServerSettings from "../../../gd/settings/server-settings/server-settings"
import {BackGround} from "../../../gd-app/panels/preferences-panel/settings-background/settings-background"

const fieldsConfig = {
    'bg': {
        type            : 'option',
        defaultValue    : BackGround.GRAY,
        options         : [BackGround.GRAY,BackGround.WHITE]
    },
}

export default class UserSettingsViewsTimeline extends ServerSettings {

    public bg : BackGround

    constructor(config: any) {

        super(config, fieldsConfig)

        this.bg                         = this.initValue('bg')
    }

    toJson() {
        const result = {}

        this.valueToJson(result, 'bg')

        return result
    }
}
